import { dayjs } from "@thalamos/common";
/**
 * Number of days after which a pending interview invite expires.
 * Only applies to invites with status "pending" — "pending-confirmed"
 * invites (where an AMHP has actively selected the doctor) do not expire.
 */
export const INTERVIEW_INVITE_EXPIRY_DAYS = 7;
/**
 * Returns true when a pending invite's last-invited timestamp is older than
 * the expiry threshold. Centralises the comparison so that changes to the
 * threshold or operator only need to happen in one place.
 */
export function isInviteExpired(lastInvitedAt) {
    return (dayjs().diff(dayjs(lastInvitedAt), "day") >= INTERVIEW_INVITE_EXPIRY_DAYS);
}
export function getFormExpiryPeriods() {
    return {
        h3Section4ExpiryPeriod: { value: 72, unit: "hours" },
        s15AmendSection4Expiry: { value: 72, unit: "hours" },
        s15AmendSection2And3Expiry: { value: 14, unit: "days" },
    };
}
//# sourceMappingURL=config.js.map